export default __webpack_public_path__ + "static/eco_packaging_green-3bbf658702e092ec409cabd861f74b5b.svg";